import { User } from '@/screens/Company-settings/Users/hooks'

export function compareUser(a: User, b: User) {
  if (a.name < b.name) {
    return -1
  }
  if (a.name > b.name) {
    return 1
  }
  return 0
}
